export const GET_DIMENSIONS_WATCHER =
  "app/WidgetResultByDimension/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/WidgetResultByDimension/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/WidgetResultByDimension/GET_DIMENSIONS_FAILED"
